export const SERVICE_IMAGES: Record<string, string> = {
  'rohrreinigung': '/images/rohrreinigung.webp',
  'klempner-notdienst': '/images/klempner-notdienst.webp',
  'sanitaer': '/images/sanitaer.webp',
};

export const LOCATION_IMAGES: string[] = [
  '/images/service-location-hero.webp',
  '/images/sanitaer-dienst.webp',
  '/images/rohrreinigung.webp',
  '/images/klempner-notdienst.webp',
  '/images/sanitaer.webp',
  '/images/hub-hero.webp',
  '/images/contact-hero.webp',
];

export const HERO_IMAGES = {
  home: "/images/hero-home.webp",
  hub: "/images/hub-hero.webp",
  contact: "/images/contact-hero.webp",
};

export const CONTENT_IMAGES = {
  tech1: "/images/tech-1.webp",
  tech2: "/images/tech-2.webp",
  customer: "/images/contact-hero.webp"
};

export const useImages = () => {
  const getServiceImage = (slug: string, width = 800, locationSlug = '') => {
    const base = SERVICE_IMAGES[slug] || SERVICE_IMAGES['rohrreinigung'];
    if (!locationSlug) return base;
    
    // Mix the base image with location images deterministically to provide variety
    let hash = 0;
    const combo = slug + locationSlug;
    for (let i = 0; i < combo.length; i++) {
      hash = combo.charCodeAt(i) + ((hash << 5) - hash);
    }
    const index = Math.abs(hash) % (LOCATION_IMAGES.length + 1);
    
    // Sometimes return the base service image, sometimes return a varied location image
    return index === 0 ? base : LOCATION_IMAGES[index - 1]; 
  };

  const getLocationImage = (id: string | number, width = 800) => {
    const idStr = String(id);
    let hash = 0;
    for (let i = 0; i < idStr.length; i++) {
      hash = idStr.charCodeAt(i) + ((hash << 5) - hash);
    }
    const index = Math.abs(hash) % LOCATION_IMAGES.length;
    return LOCATION_IMAGES[index];
  };

  const getHeroImage = (type: keyof typeof HERO_IMAGES, width = 2000) => {
    return HERO_IMAGES[type] || HERO_IMAGES.home;
  };

  const getContentImage = (type: keyof typeof CONTENT_IMAGES, width = 800) => {
    return CONTENT_IMAGES[type] || CONTENT_IMAGES.tech1;
  };

  return {
    getServiceImage,
    getLocationImage,
    getHeroImage,
    getContentImage,
  };
};
